import request from "@/utils/request";

export function login (username, password, device, isReset) {
  const data = {
    username,
    password,
    device,
    isReset
  };
  return request({
    url: "/api/users/login",
    method: "post",
    data
  });
}

export function logout () {
  return new Promise(resolve => {
    resolve(true);
  });
}

export function isUserExisted (username) {
  return request({
    url: "/api/users/exist",
    method: "get",
    params: {
      username
    }
  });
}

export function validateDeviceInfo (username, password) {
  const data = {
    username,
    password
  };
  return request({
    url: "/api/users/device",
    method: "post",
    data
  });
}


export function changePwd (username, opwd, npwd) {
  const data = {
    username,
    opwd,
    npwd
  };
  return request({
    url: "/api/users/changepwd",
    method: "post",
    data
  });
}

export function validateToken () {
  return request({
    url: "/api/users/validateToken",
    method: "get"
  });
}


export function video (id) {
  return request({
    url: "/api/users/video",
    method: "get",
    params: {
      id
    }
  });
}